(function () {
  'use strict';

  angular
    .module('directive.mini-cart', [])

    .directive('miniCart', function () {
      return {
        restrict: 'E',
        /* @ngInject */
        controller: ["$scope", "AppService", "RoutesService", function ($scope, AppService, RoutesService) {
          var ctrl = this;


          var getCart = function () {
            AppService.getCart()
              .then(function (data) {
                ctrl.hasCart = data.HasCart;
                ctrl.cartLink = !ctrl.hasCart ? '' : '/' + RoutesService.getUrlByName('Cart');
                ctrl.count = 0;
                if (ctrl.hasCart) {
                  ctrl.data = data.Cart;
                  var count = 0;
                  _.each(ctrl.data.Products, function (line) {
                    count += line.Quantity;
                  });
                  ctrl.count = count;
                }
              })
              .catch(function (error) {
                console.error(error);
              });
          };

          getCart();

          $scope.$on('cartUpdate', function () {
            getCart();
          });

        }],
        controllerAs: 'miniCartCtrl'
      };
    });

})();
